// extracted by mini-css-extract-plugin
module.exports = {"row":"styles__row___2cjgY","label":"styles__label___1PLGa","checkbox":"styles__checkbox___Xi124"};